import styled from "styled-components";
import { color } from "../../../../../shared/styles";
import { MenuItem } from "@mui/material";

export const CustomMenuItem = styled(MenuItem)`
    padding: 8px 16px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    weight: auto;

    &:hover {
        background: none;
        color: ${color.primary.BLUE_B100};
        cursor: pointer;
    }
`;

export const Anchor = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    margin-top: 4px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 999;
`;
